import React, { useState } from 'react';
import CourseCard from '../CourseCard';
import Carousel from '../Carousel';
import styles from 'LearningManager/styles/QuickSetup.module.scss';
import { Icon } from 'Components';
import CourseDetailModal from '../CourseDetailModal';
import { courseDetailMockData } from 'LearningManager/constants/createAssignment.constant';

interface Props {
	id?: string;
	title: string;
	duration: string;
	description: string;
	courses: any[];
}

const LearningSection: React.FC<Props> = ({
	id,
	title,
	duration,
	description,
	courses
}) => {
	const [showDetails, setShowDetails] = useState(false);

	return (
		<div id={id} className={styles.learningSection}>
			<div>
				<div className={styles.headingContainer}>
					<Icon type="pathIcon" role="img" />
					<div>{title}</div>
					<div className={styles.duration}>
						<Icon type="clockIcon" role="img" /> {duration}
					</div>
				</div>
				<div className={styles.description}>{description}</div>
			</div>

			<div className={styles.languages}>
				<div className={styles['languages--title']}>Languages</div>
				<div className={styles['languages--container']}>
					{[
						'English',
						'Spanish',
						'Chinese',
						'Italian',
						'French',
						'German'
					].map((lang) => (
						<span key={lang} className={styles['languages--badge']}>
							{lang}
						</span>
					))}
				</div>
			</div>

			<Carousel
				data={courses}
				itemsPerPage={4}
				renderItem={(course, i) => (
					<CourseCard
						key={course.id}
						course={course}
						index={i}
						onClick={() => setShowDetails(true)}
					/>
				)}
			/>

			<CourseDetailModal
				visible={showDetails}
				onClose={() => setShowDetails(false)}
				{...courseDetailMockData}
			/>
		</div>
	);
};

export default LearningSection;
